// extracted by mini-css-extract-plugin
export default {"container":"Funds_container__3h+t9","header":"Funds_header__E7KC7"};